import { GameVars } from "../../GameVars";
import { TrophyState } from "./TrophyState";
import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";

export class Trophy extends Phaser.Group {

    public trophyWidth: number;
    public trophyHeight: number;

    private trophyImage: Phaser.Image;
    private rays: Phaser.Image;

    constructor(game: Phaser.Game, trophyImageName: string) {

        super(game, null, "trophy", false);

        this.trophyImage = new Phaser.Image(this.game, 0, 0, "texture_atlas_2", trophyImageName);
        this.trophyImage.anchor.x = .5;
        this.trophyImage.scale.y = GameVars.scaleY;
        this.add(this.trophyImage);

        this.trophyWidth = this.trophyImage.width;
        this.trophyHeight = this.trophyImage.height;
    }

    public animate(): void {

        this.addRays();
        this.addCoinsEffect();
    }

    private addRays(): void {

        // poner rayos detras del trofeo que se apagan pasado un tiempo
        this.rays = new Phaser.Image(this.game, this.trophyImage.x + this.trophyImage.width / 2,
            this.trophyImage.y + this.trophyImage.height / 2, "texture_atlas_1", "rays");
        this.rays.anchor.set(.5);
        this.rays.scale.set(1.5);
        this.rays.blendMode = 3;

        this.addAt(this.rays, 0);

        this.game.add.tween(this.rays)
            .to({ angle: 360 }, 6000, Phaser.Easing.Linear.None, true)
            .loop();

        // poner un timer para que se quiten los rayos
        this.game.time.events.add(2500, this.removeRays, this);
    }

    private addCoinsEffect(): void {

        let i = 5;
        let coinImage: Phaser.Image;
        let rndGenerator = new Phaser.RandomDataGenerator([1, 2, 3]);

        while (i--) {

            coinImage = new Phaser.Image(this.game,
                this.trophyImage.width / 2, this.trophyImage.height / 2, "texture_atlas_5", "little_coin");

            coinImage.anchor.set(.5);
            coinImage.angle = Math.random() * 180;
            this.addAt(coinImage, 0);

            var endX: number = this.trophyImage.width / 2 + rndGenerator.between(-80, 80);
            var endY: number = this.trophyImage.height / 2 + rndGenerator.between(-90, -175);

            this.game.add.tween(coinImage)
                .to({ x: endX, y: endY }, rndGenerator.between(300, 600), Phaser.Easing.Cubic.Out, false, rndGenerator.between(0, 200))
                .to({ alpha: 0 }, 400, Phaser.Easing.Cubic.Out)
                .start();
        }

        this.game.time.events.add(1000, function () {
            TrophyState.currentInstance.updateCreditsAfterAchievedTrophy();
        }, this);

        AudioManager.getInstance().playEffect("power_up");
    }

    private removeRays(): void {

        this.game.add.tween(this.rays).to({ alpha: 0 }, 750, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.rays.destroy();
                // hacer un swipe para mostrar el primer partido del siguiente torneo
                // delay  anidado
                this.game.time.events.add(600, function (): void {
                    GameManager.showNextTournament();
                }, this);

            }, this);
    }
}
